import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { WsFooterService } from 'src/app/ws/wsFooter/ws-footer.service';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  emailSubscribe: any;
  showError: boolean = false
  showSuccess: boolean = false
  isLoading: boolean = false;
  constructor(private wsFooter: WsFooterService,private toast:ToastrService, private _commonBehaviorChangeService: CommonBehaviorChangeService) {

  }

  async subscribeEmail(email?: any) {
    if(email){
      this.toast.error('Please enter valid email');
      return;
    }
    const subscribeDetail = {
      email: this.emailSubscribe,
      is_subscribed: true
    }
    this.isLoading = true;
    this.showSuccess = true;
    const getAllBrand = this.wsFooter.addSubscribe(subscribeDetail)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.emailSubscribe = ''
        this.showError = false;
        this.isLoading = false;
        setTimeout(() => {
          this.showSuccess = false;
        }, 400);
        this._commonBehaviorChangeService.getToast("Subscribed email successfully.")
      } else {
        this.isLoading = false;
      }
    })
  }

  changeEmail(e: any) {
    this.showError = true;
  }
}
